/**
 * Created by Administrador on 20/11/2017.
 */
(function(){
    'use strict';

    angular
        .module('completeAir')
        .factory('cargoParameterService', cargoParameterService)

    cargoParameterService.$inject = ['$http', 'CONFIG', 'messageService'];

    function cargoParameterService($http, CONFIG, messageService){

        var urlBase = CONFIG.API_URL + '/' + CONFIG.API_CARGO_CONTROL + '/' + CONFIG.API + '/parameters';
        var service = {
            getCargoParameters: getCargoParameters,
            getCargoParameterList: getCargoParameterList,
            getCargoParameter: getCargoParameter,
            saveCargoParameter: saveCargoParameter,
            updateCargoParameter: updateCargoParameter,
            deleteCargoParameter: deleteCargoParameter
        }

        return service;

        function getCargoParameters(page, size){
            return $http.get(urlBase + '?page=' + page + '&size=' + size)
                .then(function(response){
                    return response;
                })
                .catch(function(){
                    messageService.findAllError('')
                });
        }

        function getCargoParameterList(){
            return $http.get(urlBase + '/list')
                .then(function(response){
                    return response;
                })
                .catch(function(){
                    messageService.findAllError('')
                });
        }

        function getCargoParameter(id){
            return $http.get(urlBase + "/" + id )
                .then(function(response){
                    return response;
                })
                .catch(function(){
                    messageService.findAError('cargoParameters')
                });
        }

        function saveCargoParameter(cargoParameter){
            return $http.post(urlBase, cargoParameter)
                .then(function(response){
                    messageService.register('cargoParameters');
                    return response;
                })
                .catch(function(){
                    messageService.registerError('cargoParameters')
                });
        }

        function updateCargoParameter(cargoParameterId, cargoParameter){
            return $http.put(urlBase + "/" + cargoParameterId, cargoParameter)
                .then(function(response){
                    messageService.registerUpdate('cargoParameters')
                    return response;
                })
                .catch(function(){
                    messageService.registerUpdateError('cargoParameters')
                });
        }

        function deleteCargoParameter(cargoParameterId){
            return $http.delete(urlBase + "/" + cargoParameterId)
                .then(function(response){
                    messageService.registerDelete('cargoParameters');
                    return response;
                })
                .catch(function(){
                    messageService.registerDeleteError('cargoParameters');
                });
        }
    }
})();
